import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0da51b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "modernization-sub-heading",
  style: {"background-color":"#fff"},
  "data-aos": "fade-up"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "WHO BENEFITS", -1))
const _hoisted_4 = { class: "card-content" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-heading mt-7 mb-5" }
const _hoisted_7 = {
  class: "modernization-sub-heading",
  "data-aos": "fade-up"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "HOW IT WORKS", -1))
const _hoisted_9 = {
  class: "modernization-sub-heading",
  "data-aos": "fade-up"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "FEATURES", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "•", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_BannerComponent = _resolveComponent("BannerComponent")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_SectionComponent = _resolveComponent("SectionComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderComponent, { screenName: "complySync" }),
    _createVNode(_component_BannerComponent, {
      imageSrc: _ctx.bannerImgUrl,
      bannerHeadingColor: _ctx.bannerHeadingColor,
      isOverlay: false,
      heading: "Navigate Compliance, Instill Confidence",
      subheading: "AI/ML Document Intelligence for ATO"
    }, null, 8, ["imageSrc", "bannerHeadingColor"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_v_row, { class: "justify-center ma-5 mb-8" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardItems, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: index,
              style: {"justify-content":"center","display":"grid"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "card",
                  style: _normalizeStyle(`background-color: ${item.color};`),
                  elevation: "0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: require(`@/assets/solutions/comply-sync/icons/${item.imgUrl}`),
                        alt: "card-image"
                      }, null, 8, _hoisted_5)
                    ])
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createElementVNode("h3", _hoisted_6, _toDisplayString(item.heading), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_v_container, { class: "d-flex justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_img, {
            src: require('@/assets/solutions/comply-sync/ComplySyncATO diagram.png'),
            alt: "ComplySync",
            class: "responsive-image",
            "max-width": "100%"
          }, null, 8, ["src"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_component_v_row, {
        class: "justify-center align-center",
        style: {"padding":"30px","max-width":"100%"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitItems, (colItems, colIndex) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              cols: "12",
              md: "12",
              lg: "6",
              key: colIndex,
              class: "feature-col-item",
              style: _normalizeStyle(colIndex === 0 ? '' : 'margin-left: -17px;')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("h3", {
                    key: index,
                    class: "feature-item d-flex"
                  }, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(item), 1)
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["style"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_SectionComponent, {
      relatedTitle: "IMPLEMENTATION OPTIONS",
      paragraphContent: "",
      sections: _ctx.sectionContents,
      cards: _ctx.cardData,
      "additional-content": _ctx.additionalContent,
      showHeading: false,
      backgroundImage: false,
      backgroundCard: true,
      customerSectionBackground: ""
    }, null, 8, ["sections", "cards", "additional-content"]),
    _createVNode(_component_FooterComponent)
  ]))
}